export default __webpack_public_path__ + "static/media/green-dropdown-thin.6108f73c.svg";